import * as React from 'react'
import { Tooltip } from '@blueprintjs/core'
import { formatDate, DATE_VERBOSE, TIME_FULL, DATE_MEDIUM } from '../utils/dateHelpers'

export interface Props {
  value: any
}

const NiceDate: React.FC<Props> = ({ value }) => {
  if (!value) return null

  const full = `${formatDate(value, DATE_VERBOSE)} at ${formatDate(value, TIME_FULL)}`
  const abrv = formatDate(value, DATE_MEDIUM)
  return <Tooltip content={full}>{abrv}</Tooltip>
}

export default React.memo(NiceDate)
